import { render, staticRenderFns } from "./DocumentType.vue?vue&type=template&id=024676ae&scoped=true"
import script from "./DocumentType.vue?vue&type=script&lang=js"
export * from "./DocumentType.vue?vue&type=script&lang=js"
import style0 from "./DocumentType.vue?vue&type=style&index=0&id=024676ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024676ae",
  null
  
)

export default component.exports